var exports = {
  "r": "body__pMmuKp",
  "Q": "content__1peHyU",
};

module.exports = exports;
